import React from "react";
import { format } from "date-fns";
import { fr } from "date-fns/locale";

export const VARIANT = {
    REGULAR: "regular",
    WITHTIME: "withtime",
};

type DateProps = {
    className?: string;
    dateTime?: string;
    variant?: string;
};

const DateComponent = ({ className = "", dateTime= "", variant }: DateProps) => {
    let dateFormated = null;

    switch (variant) {
        case VARIANT.WITHTIME:
            dateFormated = format(new Date(dateTime), "	PPPppp", { locale: fr });
            break;
        case VARIANT.REGULAR:
        default:
            dateFormated = format(new Date(dateTime), "PPP", { locale: fr });
            break;
    }

    if (!dateFormated) {
        return <></>;
    }

    return <span className={className}>{dateFormated}</span>;
};

export default DateComponent;
